import React, { useCallback, useEffect, useState } from "react";
import BuySellBtn from "../CommonTocComponent/Stock/BuySellBtn";
import MarginReqAvail from "../CommonTocComponent/Stock/MarginReqAvail";
import TermsAndConditions from "../CommonTocComponent/Terms&Conditions/TermsAndConditions";
import StockQuote from "../CommonTocComponent/TocHeader/StockQuote";
import TocStockHeader from "../CommonTocComponent/TocHeader/TocStockHeader";
import MarketDepth from "../CommonTocComponent/MarketDepth/MarketDepth";
import ChargesMain from "../CommonTocComponent/Charges/ChargesMain";
import UnderStandingMain from "../CommonTocComponent/UnderstandSection/UnderStandingMain";
import FnOProductOrder from "./FnOProductOrder";
import OrderConfirmationMain from "../CommonTocComponent/OrderConfirmation/OrderConfirmationMain";
import { useSelector } from "react-redux";
import di from "../di/servicelocator";
import { CreateTOCbuttonList, orderData, productData, understandingSectionEnum, } from "../CommonTocComponent/commonTocConstant";
import { FNOTOCIgnoreList, TOCBUYORSELL, } from "@domains/features/TOCJourney/entities/ICommonTOCEntities";
import { chargesHandler, checkTocState, fieldValidationManager, getProductValues, } from "../constant";
import { FnOOrder, FnOProducts, FnOValidity, setUISectionsFNO, } from "./FnOConstant";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DeviceContext from "@frameworks/web/utils/indentifyDevice";
import { setUISections } from "../Equity/EqTOCFunctionality";
import { OrderbookTocStateEnum, } from "@frameworks/web/components/features/OrderBook/constant";
import GenericTabs from "@frameworks/web/components/generic/GenericTabs";
import UnderStanding from "../CommonTocComponent/UnderstandSection/UnderStanding";
import ChartIQTOC from "../CommonTocComponent/ChartIQ/ChartIQTOC";
import { addCommasWithConditionalDecimal, } from "@domains/utils/numberMethods";
import { isEqual } from "underscore";
const FnOBuySellStock = (props) => {
    var _a, _b;
    const quotesDetailsEntity = useSelector((state) => state.TOCJourney.multiQuoteReducers.multiQuote.quotesDetailsEntity);
    const device = DeviceContext();
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const locationState = location.state;
    const [termCondition, setTermCondition] = React.useState(false);
    const [understanding, setUnderstanding] = React.useState(false);
    const [chartIQ, setChartIQ] = React.useState(false);
    const [marketDepth, setmarketDepth] = React.useState(false);
    const [charges, setCharges] = React.useState(false);
    const [confirmOrder, setConfirmOrder] = React.useState(false);
    const [buttonList, setButtonList] = useState();
    const [orderType, setOrderType] = useState();
    const [validity, setValidity] = useState();
    const [margin, setMargin] = React.useState(null);
    const [advancedOption, setAdvancedOption] = useState(false);
    const [underStandingSectionKey, setUnderStandingSectionKey] = useState(null);
    const [modifySection, setModifySection] = useState({
        tocState: (locationState === null || locationState === void 0 ? void 0 : locationState.tocState) || (props === null || props === void 0 ? void 0 : props.tocState) || null,
        modifyData: (locationState === null || locationState === void 0 ? void 0 : locationState.modifyData) || (props === null || props === void 0 ? void 0 : props.modifyData) || {},
    });
    const [amoOrder, setAmoOrder] = useState(null);
    const [orderConfirmationList, setOrderConfirmationList] = useState(null);
    const [activeButton, setActiveButton] = useState(() => {
        return {
            PRODUCT: FnOProducts[0].value,
            ORDER: FnOOrder[0].title,
            VALIDITY: FnOValidity[0].value,
        };
    });
    const [IsBuy, setIsBuy] = useState(() => device.isDesktop ? props === null || props === void 0 ? void 0 : props.isBuy : locationState === null || locationState === void 0 ? void 0 : locationState.isBuy);
    const [activeState, setActiveState] = useState(IsBuy ? TOCBUYORSELL.BUY : TOCBUYORSELL.SELL);
    const [tradeValues, setTradeValues] = useState({
        noOfLots: "1",
        limitPrice: "",
        stopLoss: "",
        target: "",
        triggerPrice: "",
        disclosedQuantity: "",
        agreeToTermsAndCondition: false,
        quantity: (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0
            ? (_b = (1 * parseInt((_a = quotesDetailsEntity[0]) === null || _a === void 0 ? void 0 : _a.lotSize))) === null || _b === void 0 ? void 0 : _b.toString()
            : "0",
    });
    const [formErrors, setFormErrors] = useState({
        limitPrice: { msg: "", status: false },
        stopLoss: { msg: "", status: false },
        target: { msg: "", status: false },
        triggerPrice: { msg: "", status: false },
        disclosedQuantity: { msg: "", status: false },
        quantity: { msg: "", status: false },
    });
    const [nseBse, setNseBse] = React.useState("NFO");
    const [refreshMargin, setrefreshMargin] = useState(null);
    const multiQuoteLoader = useSelector((state) => state.TOCJourney.multiQuoteReducers.multiQuoteLoader, isEqual);
    const rmsDetails = useSelector((state) => state.TOCJourney.rmsDetails.rmsSublimits, isEqual);
    const { userID } = useSelector((state) => state.accountDetailsReducer, isEqual);
    const { data: amo, loader: amoLoader, errorData: amoError, } = useSelector((state) => state.TOCJourney.AMOStatus, isEqual);
    const { data: checkMarginData, loader: checkMarginLoader, errorData: checkMarginError, } = useSelector((state) => state.TOCJourney.checkMargin, isEqual);
    const CreatebuttonList = async (isAmo, isBOSelected, isModify, modifyData) => {
        let ignoreList = isAmo ? [...FNOTOCIgnoreList, "BO"] : FNOTOCIgnoreList;
        let FinalButtons = await CreateTOCbuttonList(nseBse, ignoreList, isAmo, isModify, modifyData, isBOSelected);
        return FinalButtons;
    };
    const amoSelecterHandler = async (val, textContent) => {
        var _a, _b;
        await setAmoOrder(val);
        let isModify = (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
            ? checkTocState(locationState === null || locationState === void 0 ? void 0 : locationState.tocState, OrderbookTocStateEnum.MODIFY)
            : (props === null || props === void 0 ? void 0 : props.tocState)
                ? checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)
                : false;
        let isBOOrder = textContent === FnOProducts[2].title;
        let buttonList = await CreatebuttonList(val, isBOOrder, isModify, modifySection.modifyData);
        await setButtonList(buttonList === null || buttonList === void 0 ? void 0 : buttonList.products);
        await setOrderType(buttonList === null || buttonList === void 0 ? void 0 : buttonList.orderType);
        await setValidity(buttonList === null || buttonList === void 0 ? void 0 : buttonList.validity);
        if (val) {
            await setActiveButton(Object.assign(Object.assign({}, activeButton), { ORDER: (_a = FnOOrder[1]) === null || _a === void 0 ? void 0 : _a.title }));
            if (activeButton.PRODUCT === FnOProducts[2].value) {
                await setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: FnOProducts[0].title }));
            }
        }
        if (textContent) {
            await setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: textContent, ORDER: textContent == FnOProducts[2].value
                    ? (_b = FnOOrder[1]) === null || _b === void 0 ? void 0 : _b.title
                    : activeButton.ORDER }));
        }
    };
    const getChargesData = () => {
        const req = {
            userID: userID,
            reqBody: {
                action: activeState,
                prd: getProductValues(buttonList, activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT) ||
                    (activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT),
                price: tradeValues.limitPrice,
                qty: (parseInt(tradeValues.noOfLots) *
                    parseInt(quotesDetailsEntity[0].lotSize)).toString(),
                sym: quotesDetailsEntity[0].symbol,
            },
        };
        di.tocJourney.brokerCharge(req);
    };
    const removeMarginData = () => {
        di.tocJourney.flushMarginData();
    };
    const closeTOC = () => {
        removeMarginData();
        !device.isDesktop ? navigate(-1) : props.setShowTOC(false);
    };
    const updateMargin = () => {
        di.tocJourney.checkMargin(refreshMargin);
    };
    const handleConfirmPage = useCallback(() => {
        return (React.createElement(OrderConfirmationMain, { setConfirmOrder: confirmOrderLoader, show: confirmOrder, orderConfirmationList: orderConfirmationList, exchange: "NFO", action: activeState, activeButton: activeButton, tradeValues: tradeValues, amoOrder: amoOrder, closeToc: closeTOC, tocState: modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, modifyData: modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData, afterModifyAction: props === null || props === void 0 ? void 0 : props.afterModifyAction, afterMarketRedirect: locationState === null || locationState === void 0 ? void 0 : locationState.redirectUrl, buttonList: buttonList }));
    }, [confirmOrder]);
    const disableSell = () => {
        return ((activeButton.PRODUCT === FnOProducts[2].title &&
            !tradeValues.agreeToTermsAndCondition) ||
            !activeButton.ORDER ||
            !activeButton.PRODUCT ||
            tradeValues.quantity <= "0" ||
            Object.values(formErrors)
                .map((x) => x.status)
                .some((x) => x) ||
            !quotesDetailsEntity);
    };
    const confirmOrderLoader = async (val) => {
        if (val) {
            await di.tocJourney.flushPlaceOrderError();
            await di.tocJourney.flushPlaceOrderData();
            setConfirmOrder(val);
        }
        else {
            setConfirmOrder(val);
        }
    };
    const proceedToPlaceOrder = async () => {
        await createFormErrorFields(true)
            .then((data) => {
            setFormErrors(data);
            if (Object.values(data)
                .map((x) => x.status)
                .some((x) => x)) {
                disableSell();
            }
            else {
                updateMargin();
                confirmOrderLoader(true);
            }
        })
            .catch((err) => { });
    };
    const createFormErrorFields = async (isSubmit) => {
        return new Promise((res, error) => {
            let getUIstatus = setUISectionsFNO(activeButton);
            let isModify = checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.MODIFY);
            const validation = fieldValidationManager(tradeValues, activeState, quotesDetailsEntity[0]);
            res({
                limitPrice: !(getUIstatus === null || getUIstatus === void 0 ? void 0 : getUIstatus.disabledLimitInput)
                    ? isSubmit
                        ? validation.getLimitValidation
                        : !tradeValues.limitPrice
                            ? { msg: "", status: true }
                            : validation.getLimitValidation
                    : { msg: "", status: false },
                triggerPrice: getUIstatus.showTriggerPrice
                    ? isSubmit
                        ? validation.getTriggerValidation
                        : !tradeValues.triggerPrice
                            ? { msg: "", status: true }
                            : validation.getTriggerValidation
                    : { msg: "", status: false },
                stopLoss: getUIstatus.showStopLoss
                    ? isSubmit
                        ? validation.getStoplossValidation
                        : !tradeValues.stopLoss && !isModify
                            ? { msg: "", status: true }
                            : validation.getStoplossValidation
                    : { msg: "", status: false },
                target: getUIstatus.showTargetPrice
                    ? isSubmit
                        ? validation.getTargetValidation
                        : !tradeValues.target && !isModify
                            ? { msg: "", status: true }
                            : validation.getTargetValidation
                    : { msg: "", status: false },
            });
        });
    };
    const updateModifiedData = React.useMemo(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        return {
            noOfLots: (Number((_a = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _a === void 0 ? void 0 : _a.netQty) /
                Number((_b = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _b === void 0 ? void 0 : _b.lotSize)).toString(),
            limitPrice: ((_c = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _c === void 0 ? void 0 : _c.limitPrice)
                ? (_d = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _d === void 0 ? void 0 : _d.limitPrice
                : "",
            triggerPrice: ((_e = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _e === void 0 ? void 0 : _e.triggerPrice)
                ? (_f = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _f === void 0 ? void 0 : _f.triggerPrice
                : "",
            disclosedQuantity: +((_g = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _g === void 0 ? void 0 : _g.discloseQty) > 0
                ? (_h = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _h === void 0 ? void 0 : _h.discloseQty
                : "",
            quantity: ((_j = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _j === void 0 ? void 0 : _j.netQty)
                ? (_k = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _k === void 0 ? void 0 : _k.netQty
                : "",
            agreeToTermsAndCondition: false,
        };
    }, [modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData]);
    React.useEffect(() => {
        if (activeButton) {
            createFormErrorFields().then((data) => {
                setFormErrors(data);
            });
        }
    }, [activeButton, activeState, advancedOption]);
    React.useEffect(() => {
        if (quotesDetailsEntity &&
            (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0 &&
            !(props === null || props === void 0 ? void 0 : props.tocState) &&
            !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState)) {
            setTradeValues(Object.assign(Object.assign({}, tradeValues), { limitPrice: quotesDetailsEntity[0].lastTradedPrice }));
        }
    }, [quotesDetailsEntity]);
    useEffect(() => {
        !amoLoader &&
            !amoError.isOpen &&
            !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState) &&
            !(props === null || props === void 0 ? void 0 : props.tocState) &&
            amoSelecterHandler(amo === null || amo === void 0 ? void 0 : amo.status);
    }, [amo, amoLoader, amoError]);
    useEffect(() => {
        if (userID)
            di.tocJourney.getRmsSublimits(userID);
    }, [userID]);
    useEffect(() => {
        var _a, _b, _c;
        activeButton &&
            tradeValues &&
            setOrderConfirmationList([
                {
                    title: "Action",
                    value: activeState,
                },
                {
                    title: "Product type",
                    value: (_a = buttonList === null || buttonList === void 0 ? void 0 : buttonList.find((x) => x.title === (activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT))) === null || _a === void 0 ? void 0 : _a.value,
                },
                {
                    title: "Order type",
                    value: (_b = orderType === null || orderType === void 0 ? void 0 : orderType.find((x) => x.title === (activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER))) === null || _b === void 0 ? void 0 : _b.title,
                },
                {
                    title: "No of Lots",
                    value: `${addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.noOfLots)}  ${(quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0
                        ? `(Qty:${addCommasWithConditionalDecimal(Number((_c = quotesDetailsEntity[0]) === null || _c === void 0 ? void 0 : _c.lotSize) *
                            Number(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.noOfLots))})`
                        : ""}`,
                },
                {
                    title: "Limit price",
                    value: addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.limitPrice),
                    isHide: setUISections(activeButton, true).disabledLimitInput,
                },
                {
                    title: "Trigger price",
                    value: addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.triggerPrice),
                    isHide: !setUISections(activeButton, true).showTriggerPrice,
                },
                {
                    title: "Stop Loss",
                    value: `-${addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.stopLoss)} pts`,
                    isHide: !setUISections(activeButton, true).showStopLoss,
                },
                {
                    title: "Target",
                    value: `+${addCommasWithConditionalDecimal(tradeValues === null || tradeValues === void 0 ? void 0 : tradeValues.target)} pts`,
                    isHide: !setUISections(activeButton, true).showTargetPrice,
                },
            ]);
    }, [activeState, activeButton, margin, tradeValues]);
    useEffect(() => {
        if (localStorage.getItem("acc_data") &&
            !(props === null || props === void 0 ? void 0 : props.tocState) &&
            !(locationState === null || locationState === void 0 ? void 0 : locationState.tocState)) {
            CreatebuttonList(amoOrder).then((list) => {
                setButtonList(list === null || list === void 0 ? void 0 : list.products);
                setOrderType(list === null || list === void 0 ? void 0 : list.orderType);
                setValidity(list === null || list === void 0 ? void 0 : list.validity);
            });
        }
    }, []);
    useEffect(() => {
        if ((device === null || device === void 0 ? void 0 : device.isMobile) && (params === null || params === void 0 ? void 0 : params.symbol)) {
            di.tocJourney.getMultiQuoteData({
                symLst: [params === null || params === void 0 ? void 0 : params.symbol],
            });
        }
    }, [params === null || params === void 0 ? void 0 : params.symbol]);
    useEffect(() => {
        !checkMarginLoader &&
            !checkMarginError.isOpen &&
            setMargin(checkMarginData);
    }, [checkMarginData, checkMarginLoader, checkMarginError]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (updateModifiedData && ((props === null || props === void 0 ? void 0 : props.tocState) || (locationState === null || locationState === void 0 ? void 0 : locationState.tocState))) {
            setTradeValues(updateModifiedData);
            setNseBse(((_a = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _a === void 0 ? void 0 : _a.exchange)
                ? (_b = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _b === void 0 ? void 0 : _b.exchange
                : nseBse);
            createFormErrorFields().then((data) => {
                setFormErrors(data);
            });
            let isModify = (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
                ? checkTocState(locationState === null || locationState === void 0 ? void 0 : locationState.tocState, OrderbookTocStateEnum.MODIFY)
                : (props === null || props === void 0 ? void 0 : props.tocState)
                    ? checkTocState(props === null || props === void 0 ? void 0 : props.tocState, OrderbookTocStateEnum.MODIFY)
                    : false;
            let modifyData = (locationState === null || locationState === void 0 ? void 0 : locationState.modifyData)
                ? locationState === null || locationState === void 0 ? void 0 : locationState.modifyData
                : props === null || props === void 0 ? void 0 : props.modifyData;
            setModifySection({
                tocState: (locationState === null || locationState === void 0 ? void 0 : locationState.tocState)
                    ? locationState === null || locationState === void 0 ? void 0 : locationState.tocState
                    : props === null || props === void 0 ? void 0 : props.tocState,
                modifyData: modifyData,
            });
            setAmoOrder((_c = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _c === void 0 ? void 0 : _c.isAmo);
            let isBOOrder = (modifyData === null || modifyData === void 0 ? void 0 : modifyData.productType) == FnOProducts[2].title;
            CreatebuttonList((_d = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _d === void 0 ? void 0 : _d.isAmo, isBOOrder, isModify, modifyData).then((list) => {
                setButtonList(list === null || list === void 0 ? void 0 : list.products);
                setOrderType(list === null || list === void 0 ? void 0 : list.orderType);
                setValidity(list === null || list === void 0 ? void 0 : list.validity);
            });
            setActiveButton(Object.assign(Object.assign({}, activeButton), { PRODUCT: (_e = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _e === void 0 ? void 0 : _e.productType, ORDER: (_f = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _f === void 0 ? void 0 : _f.orderType, VALIDITY: (_g = modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData) === null || _g === void 0 ? void 0 : _g.validity }));
        }
    }, [updateModifiedData]);
    return (React.createElement(React.Fragment, null, confirmOrder ? (React.createElement(React.Fragment, null, handleConfirmPage())) : charges ? (React.createElement(ChargesMain, { show: charges, setShow: setCharges })) : marketDepth ? (React.createElement(MarketDepth, { setmarketDepth: setmarketDepth, show: marketDepth, setNseBse: setNseBse, nseBse: nseBse, isTabHide: true })) : chartIQ ? (React.createElement(ChartIQTOC, { symbol: quotesDetailsEntity ? quotesDetailsEntity[0].symbol : "", instru: quotesDetailsEntity ? quotesDetailsEntity[0].asTyp : "", show: chartIQ, goBack: () => setChartIQ(false) })) : (React.createElement(React.Fragment, null, termCondition ? (React.createElement(TermsAndConditions, { show: termCondition, setShow: setTermCondition })) : understanding ? (React.createElement(UnderStandingMain, { show: understanding, setShow: setUnderstanding, content: React.createElement(GenericTabs, { defaultActiveKey: underStandingSectionKey, tabsArray: [
                {
                    title: "Product Type",
                    eventKey: understandingSectionEnum.PRODUCT,
                    tabContent: (React.createElement(UnderStanding, { data: productData, activeKey: activeButton === null || activeButton === void 0 ? void 0 : activeButton.PRODUCT })),
                },
                {
                    title: "Order Type",
                    eventKey: understandingSectionEnum.ORDER,
                    tabContent: (React.createElement(UnderStanding, { data: orderData, activeKey: activeButton === null || activeButton === void 0 ? void 0 : activeButton.ORDER })),
                },
            ] }) })) : (React.createElement(React.Fragment, null,
        !multiQuoteLoader && (React.createElement(TocStockHeader, { children: React.createElement(StockQuote, { stockQuoteDetails: quotesDetailsEntity, exchangeType: nseBse, hideHoldings: true, setChartIQ: () => setChartIQ(true), textInsteadToggle: true }) })),
        React.createElement(FnOProductOrder, { setTermCondition: setTermCondition, setUnderstanding: setUnderstanding, setUnderStandingSectionKey: setUnderStandingSectionKey, setmarketDepth: setmarketDepth, multiQuoteEntity: (quotesDetailsEntity === null || quotesDetailsEntity === void 0 ? void 0 : quotesDetailsEntity.length) > 0
                ? quotesDetailsEntity[0]
                : {}, setrefreshMargin: setrefreshMargin, activeState: activeState, buttonList: buttonList, orderType: orderType, validity: validity, setActiveButton: setActiveButton, activeButton: activeButton, tradeValues: tradeValues, setTradeValues: setTradeValues, amoOrder: amoOrder, setAmoOrder: amoSelecterHandler, margin: margin, formErrors: formErrors, setFormErrors: setFormErrors, advancedOption: advancedOption, setAdvancedOption: setAdvancedOption, isModifyOrder: checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.MODIFY), modifyData: modifySection === null || modifySection === void 0 ? void 0 : modifySection.modifyData }),
        React.createElement("div", { className: "bottom-contents" },
            React.createElement(MarginReqAvail, { setCharges: setCharges, getChargesData: getChargesData, updateMargin: updateMargin, margin: margin, disableCharges: chargesHandler(tradeValues), availableCash: rmsDetails.cshAvl }),
            React.createElement(BuySellBtn, { refreshLabelTitle: !IsBuy ? TOCBUYORSELL.BUY : TOCBUYORSELL.SELL, buySellRefresh: (modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState)
                    ? checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.DEFAULT)
                    : true, cancelAction: closeTOC, rightButton: {
                    btnTyp: activeState === TOCBUYORSELL.SELL
                        ? "red-btn"
                        : "green-btn",
                    value: checkTocState(modifySection === null || modifySection === void 0 ? void 0 : modifySection.tocState, OrderbookTocStateEnum.MODIFY)
                        ? "Modify"
                        : activeState === TOCBUYORSELL.SIP
                            ? "BUY"
                            : activeState,
                    className: "w-100",
                    onClick: () => proceedToPlaceOrder(),
                    disabled: disableSell(),
                }, onCallBackFunction: () => {
                    setIsBuy(!IsBuy);
                    setActiveState(!IsBuy ? TOCBUYORSELL.BUY : TOCBUYORSELL.SELL);
                } }))))))));
};
export default FnOBuySellStock;
